import ConfirmActionModal from './ConfirmActionModal';

export default ConfirmActionModal;
